<template>
  <div>
    <van-row>
      <van-col class="main-body" :offset="offset" :span="span">
        <div class="body-header">
          <span>{{ CompanyName }}危险废物信息</span>
        </div>
        <van-list>
          <van-cell>
            <div class="text item">
              <span class="text-tt">废物名称：</span><span>{{ FName }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">废物类别：</span><span>{{ FType }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">废物代码：</span><span>{{ FCode }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">废物形态：</span><span>{{ FForm }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">废物特性：</span><span>{{ FNature }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">主要成分：</span><span>{{ FMainCom }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">有害成分：</span
              ><span>{{ FHarmfulCom }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">注意事项：</span><span>{{ FNote }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">数字识别码：</span
              ><span>{{ FNumCode }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">产生/收集单位：</span
              ><span>{{ FCompany }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">联系人：</span
              ><span>{{ FContactName }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">联系方式：</span
              ><span>{{ FContactPhone }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">产生日期：</span><span>{{ FDate }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">废物重量：</span><span>{{ FWeight }}</span>
            </div>
          </van-cell>
          <van-cell>
            <div class="text item">
              <span class="text-tt">备注：</span><span>{{ FRemark }}</span>
            </div>
          </van-cell>
        </van-list>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: "warninfo",
  created() {  
    document.title = '危险废物信息';  
  },
  data() {
    return {
      guid: this.$route.params.id,
      FName: "",
      FType: "",
      FCode: "",
      FForm: "",
      FNature: "",
      FMainCom: "",
      FHarmfulCom: "",
      FNote: "",
      FNumCode: "",
      FCompany: "",
      FContactName: "",
      FContactPhone: "",
      FDate: "",
      FWeight: "",
      FRemark: "",
      CompanyName: "",
      windowWidth: 0,
      offset: 0,
      span: 0
    };
  },
  components: {},
  mounted() {
    window.addEventListener("resize", this.updateWidth);
    this.updateWidth();
    this.getInfo();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
  },
  methods: {
    //自适应页面宽度
    updateWidth() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth < 768) {
        this.offset = 0;
        this.span = 24;
      } else if (this.windowWidth >= 768 && this.windowWidth < 992) {
        this.offset = 4;
        this.span = 16;
      } else if (this.windowWidth >= 992 && this.windowWidth < 1200) {
        this.offset = 6;
        this.span = 12;
      } else {
        this.offset = 8;
        this.span = 8;
      }
    },
    getInfo() {
      const baseURL = this.GLOBAL.baseURL;
      let _this = this;
      _this.$ajax
        .get(baseURL + "warn/info_code", {
          params: {
            ID: this.guid
          },
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(response => {
          var data = response.data;
          _this.FName = data.FName;
          _this.FType = data.FType;
          _this.FCode = data.FCode;
          _this.FForm = data.FForm;
          _this.FNature = data.FNature;
          _this.FMainCom = data.FMainCom;
          _this.FHarmfulCom = data.FHarmfulCom;
          _this.FNote = data.FNote;
          _this.FNumCode = data.FNumCode;
          _this.FCompany = data.FCompany;
          _this.FContactName = data.FContactName;
          _this.FContactPhone = data.FContactPhone;
          _this.FDate = data.FDate;
          _this.FWeight = data.FWeight;
          _this.FRemark = data.FRemark;
          _this.CompanyName = data.CompanyName;
        });
    }
  }
};
</script>

<style scoped>
.text {
  font-size: 14px;
}
.text-tt {
  color: grey;
}
.body-header {
  text-align: center;
  font-size: 1.3em;
  font-weight: bold;
  padding: 13px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/warnInfo.vue